import { slugs } from '@/constants/slugs'

export interface NoFeesValuesType {
  video?: string
  image?: string
  bgColor: string
}

export const NoFeesVales: Record<string, NoFeesValuesType> = {
  [slugs.kingOfKings]: {
    video: '',
    bgColor: 'gray',
    image:
      'https://images.angelstudios.com/image/upload/v1743712654/king-of-kings/tkok-isolated-waller-willa-img-01.png',
  },
}
